export default __webpack_public_path__ + "static/partnerColorIcon12-9d50c1a9a83e0861ae027e52dff87479.svg";